import { type DrawerProps } from "antd"

export const onCloseDrawer =
    (onClose: () => void): DrawerProps["onClose"] =>
    (e) => {
        const { key } = e.nativeEvent as KeyboardEvent
        if (key === "Escape") {
            onClose()
        }
        const target = e?.target as HTMLElement
        if (target && target.closest && target.closest(".ant-drawer-close")) {
            onClose()
        }
    }
